import styled from 'styled-components'

export const Warning = styled.div`
  color: var(--disabled);
  font-size: var(--font-extra-small);
  font-weight: 500;
  min-height: var(--size-medium);
`
